module.exports = __webpack_public_path__ + "img/guestbook.e59de1c0.gif";